/** Shared Daily Rate Basis options for Purchase Advice (Buyer / Seller). */
export const DAILY_RATE_BASIS_OPTIONS: Record<string, string> = {
  '360': '30/360',
  '365': '30/365',
  actual_360: 'Actual/360',
  actual_365: 'Actual/365',
}

/** Year-day denominator for Interest Paid Amount. Defaults to 360 (legacy). */
export const getDailyRateYearDays = (basis?: string | number | null): number => {
  const value = `${basis ?? ''}`
  if (value === '365' || value === 'actual_365') return 365
  return 360
}

/** Whether day count uses 30-day months (30/360, 30/365). */
export const isThirtyDayMonthBasis = (basis?: string | number | null): boolean => {
  const value = `${basis ?? ''}`
  return value === '360' || value === '365'
}
